(function () {
  'use strict';

  var bar = document.getElementById('te-sticky-atc');
  if (!bar) return;

  // Watch the main ATC button — show bar when it's out of view
  var mainBtn = document.querySelector('.product-form__submit');
  if (mainBtn) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('te-sticky-atc--visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { rootMargin: '0px 0px -20px 0px', threshold: 0 });
    io.observe(mainBtn);
  }

  // Get the currently selected variant ID from the main product form
  function getVariantId() {
    var mainInput = document.querySelector('.product-form form input[name="id"]');
    return mainInput ? mainInput.value : bar.dataset.variantId;
  }

  // Keep sticky price in sync with main product form price
  function syncPrice() {
    var mainPrice = document.querySelector('.product .price-item--regular');
    var stickyPrice = bar.querySelector('.te-sticky-atc__price');
    if (mainPrice && stickyPrice && mainPrice.textContent.trim()) {
      stickyPrice.textContent = mainPrice.textContent.trim();
    }
  }

  // Watch main price element for variant-driven changes
  var priceEl = document.querySelector('.product .price__container');
  if (priceEl) {
    new MutationObserver(syncPrice).observe(priceEl, {
      childList: true, subtree: true, characterData: true
    });
  }

  // Handle sticky ATC form submit
  var form = bar.querySelector('.te-sticky-atc__form');
  var btn = bar.querySelector('.te-sticky-atc__btn');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var variantId = getVariantId();
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Try Again';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 1600);
      } else {
        btn.textContent = 'Added ✓';
        // Open cart drawer via Dawn's Section Rendering API
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.renderContents(data);
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 1600);
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    });
  });
})();
